/** Synchronous org provisioning — user should keep the tab open briefly. */
export const SIGNUP_PHASE1_KEEP_OPEN_MESSAGE =
  'Please keep this page open while we create your account. This usually takes less than a minute.';

/** Immediate success after single-pool provisioning. */
export const SIGNUP_PROVISIONED_MESSAGE =
  'Your account is ready. Check your email for login details and a link to the BILDIT VXE.';

export const TRIAL_STARTED_HEADING = 'Full access for 14 days';

export const TRIAL_STARTED_LEAD =
  'Explore every paid BILDIT feature for 14 days. After that, you’ll keep a free developer sandbox forever—no credit card required.';

export const TRIAL_STARTED_NEXT_STEP =
  'Next, we’ll open the BILDIT VXE and start the guided tutorial. Use the password you set if you sign in later.';

export const TRIAL_STARTED_CTA_BUTTON = 'Go to Tutorial';

/**
 * Copy for the post-signup CTA before opening the VXE tutorial.
 * @returns {{ heading: string, lead: string, body: string, buttonLabel: string }}
 */
export function getTrialStartedCtaCopy() {
  return {
    heading: TRIAL_STARTED_HEADING,
    lead: TRIAL_STARTED_LEAD,
    body: TRIAL_STARTED_NEXT_STEP,
    buttonLabel: TRIAL_STARTED_CTA_BUTTON,
  };
}

/** @deprecated Use getTrialStartedCtaCopy — kept for legacy signup flows. */
export const SIGNUP_LOGIN_INTERSTITIAL_TITLE = 'Check your email before you log in';

/** @deprecated Use getTrialStartedCtaCopy — kept for legacy signup flows. */
export const SIGNUP_LOGIN_INTERSTITIAL_BUTTON = 'Continue to Login';

/**
 * @deprecated Legacy interstitial for emailed temporary passwords.
 * @param {string} [email]
 * @returns {{ title: string, body: string, buttonLabel: string }}
 */
export function getSignupLoginInterstitialCopy(email) {
  const address = String(email || '').trim();
  const body = address
    ? `Next you will be taken to the BILDIT login. We generated a password and sent it to ${address}. Sign in with that email and the emailed password.`
    : 'Next you will be taken to the BILDIT login. We generated a password and sent it to the email you signed up with. Sign in with that email and the emailed password.';
  return {
    title: SIGNUP_LOGIN_INTERSTITIAL_TITLE,
    body,
    buttonLabel: SIGNUP_LOGIN_INTERSTITIAL_BUTTON,
  };
}
